import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
})

export default class BetterWebCoZaHome extends Vue {
  public readonly ParallaxLogos = [
    {
      imageUrl: '/img/svgs/BetterWebsite-BetterCorp.svg',
    },
    {
      imageUrl: '/img/svgs/BetterWebsite-BetterFibre.svg',
    },
    {
      imageUrl: '/img/svgs/BetterWebsite-BetterMarketing.svg',
    },
    {
      imageUrl: '/img/svgs/BetterWebsite-BetterTech.svg',
    },
    {
      imageUrl: '/img/svgs/BetterWebsite-BetterBnB.svg',
    },
  ];
}
